import React, { useMemo } from 'react';
import { find, toLower, includes, get } from 'lodash';
import TimeZonesView from '../../../controls/ValueViews/TimeZonesView';
import EntityField from '../internal/EntityField';
import FormSelectBox from '../../../controls/FormSelectBox';
import { getTimeZones } from '../../../../utils/timezone';
import useLabel from '../../../utils/Translations/useLabel';
import useFieldReset from '../../../../data/hooks/useFieldReset';
import useCountries from '../../../../data/hooks/useCountries';
import useCurrentUser from '../../../../data/hooks/useCurrentUser';
import { DEFAULT_LANGUAGE } from '../../../utils/Translations/helpers/constants';
const SUBSTR = 4;
const TimeZonesField = ({ name = 'timeZone', label = '', required = false, countryId, dataCy, ...rest }) => {
    const { me } = useCurrentUser();
    const currentLanguage = get(me, 'preferences.UI_LANGUAGE', DEFAULT_LANGUAGE);
    const timeZones = useMemo(() => getTimeZones(currentLanguage), [
        currentLanguage,
    ]);
    const { countries } = useCountries();
    const _label = useLabel('Time Zones', label);
    const country = useMemo(() => (countryId ? find(countries, { id: countryId }) : ''), [countries, countryId]);
    const defaultTimeZone = useMemo(() => {
        if (!country) {
            return '';
        }
        let tz = find(timeZones, tz => includes(toLower(tz.name), toLower(country.capitalCity)));
        if (!tz) {
            tz = find(timeZones, tz => {
                var _a;
                return includes(toLower(tz.name), toLower((_a = country === null || country === void 0 ? void 0 : country.capitalCity) === null || _a === void 0 ? void 0 : _a.substr(0, SUBSTR)));
            });
        }
        return tz === null || tz === void 0 ? void 0 : tz.value;
    }, [country, timeZones]);
    useFieldReset(name, country, defaultTimeZone, !!country, false);
    return (<EntityField name={name} required={required} {...rest}>
      {(editable, field, { required, disabled }) => editable ? (<FormSelectBox dataCy={dataCy} disabled={disabled} options={timeZones} placeholder={_label} {...field} liveSearch required={required}/>) : (<TimeZonesView label={_label} value={field.input.value}/>)}
    </EntityField>);
};
export default TimeZonesField;
